import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { User, Mail, Phone, Shield, Headphones } from "lucide-react";
import { api, getStoredUser } from "@/lib/api";

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const stored = getStoredUser();
  const site = useOutletContext();

  useEffect(() => {
    api.get("/customer/profile").then(r => setProfile(r.data)).catch(() => {});
  }, []);

  const user = profile?.user || stored || {};

  return (
    <div className="pt-6 space-y-6">
      <h2 className="font-heading font-bold text-lg text-brand-nav">My Profile</h2>

      {/* Avatar */}
      <div className="flex flex-col items-center">
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-brand-primary to-brand-accent flex items-center justify-center text-white text-2xl font-bold">
          {(user.name || "?")[0].toUpperCase()}
        </div>
        <p className="mt-3 font-heading font-bold text-xl text-brand-nav">{user.name || "Customer"}</p>
        <span className="text-xs bg-brand-primary/10 text-brand-primary font-semibold px-3 py-1 rounded-full mt-1 uppercase tracking-wider">
          {user.role || "customer"}
        </span>
      </div>

      {/* Info Cards */}
      <div className="space-y-3">
        <div className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-4">
          <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center"><Mail className="w-5 h-5 text-blue-500" /></div>
          <div>
            <p className="text-xs text-slate-400">Email</p>
            <p className="text-sm font-semibold text-slate-700">{user.email || "—"}</p>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-4">
          <div className="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center"><Phone className="w-5 h-5 text-green-500" /></div>
          <div>
            <p className="text-xs text-slate-400">Mobile</p>
            <p className="text-sm font-semibold text-slate-700">{user.mobile || "—"}</p>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4 flex items-center gap-4">
          <div className="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center"><Shield className="w-5 h-5 text-purple-500" /></div>
          <div>
            <p className="text-xs text-slate-400">Account Status</p>
            <p className="text-sm font-semibold text-green-600">Active</p>
          </div>
        </div>
      </div>

      {/* ── Help & Support ───────────────────────────────────── */}
      <div className="pt-2">
        <h3 className="font-heading font-semibold text-sm text-slate-400 uppercase tracking-wider mb-3 flex items-center gap-2">
          <Headphones className="w-4 h-4" /> Help & Support
        </h3>
        <div className="bg-white rounded-xl border border-slate-200 p-5 space-y-4 shadow-sm">
          <p className="text-sm text-slate-500 border-b border-slate-100 pb-3">If you need assistance, please contact your cable operator via the details below.</p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-1">
            <div>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Email</p>
              <p className="text-sm font-medium text-slate-800 mt-1 break-all">{site?.email || "Not provided"}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Phone</p>
              <p className="text-sm font-medium text-slate-800 mt-1">{site?.phone || "Not provided"}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">WhatsApp</p>
              <p className="text-sm font-medium text-slate-800 mt-1">{site?.whatsapp || "Not provided"}</p>
            </div>
          </div>
        </div>
      </div>

      <p className="text-xs text-center text-slate-400 pt-4">
        To update your profile, contact your cable operator.
      </p>
    </div>
  );
}
